<div class="admin-dialog">
  <!-- Header -->
  <div class="admin-dialog__header">
    <div class="admin-dialog__header-left">
      <h2 class="admin-dialog__title" i18n="@@adminSystem.distributorDetails.title.info">代理店情報</h2>
    </div>
    <button mat-icon-button class="admin-dialog__close" (click)="onNoClick()" aria-label="Close dialog" type="button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div class="admin-dialog__content">
    <form [formGroup]="distributorFormGroup">

      <!-- @if (distributorId == null && this.common.hasAllSectionGroupManagement()) {
        <div class="admin-dialog__section">
          <div class="form-label">
            <span class="form-label__text" i18n="@@adminSystem.distributorDetails.label.assignAgent">エージェント割り当て</span>
          </div>
          <mat-radio-group formControlName="assignAgent" class="form-radio-group">
            @for (aa of assignAgent; track aa) {
              <mat-radio-button [value]="aa.value" color="primary">{{ aa.desc }}</mat-radio-button>
            }
          </mat-radio-group>
        </div>
      } -->

      <div class="admin-dialog__section">
        <div class="form-label">
          <span class="form-label__text" i18n="@@adminSystem.distributorDetails.label.name">代理店名</span>
          <span class="form-label__required">*</span>
        </div>
        <mat-form-field appearance="outline" class="form-field">
          <input matInput formControlName="name" />
          <mat-icon matSuffix class="material-icons-outlined">business</mat-icon>
          @if (distributorFormGroup.get('name')?.hasError('required')) {
            <mat-error i18n="@@adminSystem.distributorDetails.error.required">必須項目です</mat-error>
          }
        </mat-form-field>
      </div>

      @if(distributorId){
        <div class="admin-dialog__section">
          <div class="form-label">
            <span class="form-label__text" i18n="@@adminSystem.distributorDetails.label.id">ID</span>
          </div>
          <mat-form-field appearance="outline" class="form-field">
            <input matInput formControlName="id" />
            <mat-icon matSuffix class="material-icons-outlined">badge</mat-icon>
          </mat-form-field>
        </div>
      }

      <div class="admin-dialog__divider"></div>

      <app-addresses-form [addressesForm]="getAddressesGroup()"></app-addresses-form>

      <div class="admin-dialog__divider"></div>

      <app-contact-details-form [contactDetailsForm]="getContactDetailsGroup()"></app-contact-details-form>

      <div class="admin-dialog__divider"></div>

      <app-billing-info-form #billingInfoFormComp [billingInfoForm]="getBillingInfoGroup()"></app-billing-info-form>

      <!-- <div class="admin-dialog__divider"></div>

      <app-billing-source-form [billingSourceForm]="getBillingSourceGroup()"></app-billing-source-form>
      
      <div class="admin-dialog__divider"></div>

      <app-billing-terms-form [billingTermsForm]="getBillingTermsGroup()"></app-billing-terms-form> -->

      <div class="admin-dialog__divider"></div>

      <div class="admin-dialog__section">
        <div class="form-label">
          <span class="form-label__text" i18n="@@adminSystem.distributorDetails.label.maxSectionGroups">最大セクショングループ数</span>
          <span class="form-label__required">*</span>
        </div>
        <mat-form-field appearance="outline" class="form-field">
          <input matInput formControlName="maxSectionGroups" type="number"/>
          @if (distributorFormGroup.get('maxSectionGroups')?.hasError('required')) {
            <mat-error i18n="@@adminSystem.distributorDetails.error.required">必須項目です</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="admin-dialog__divider"></div>
      
      <div class="admin-dialog__section">
        <div class="form-label">
          <span class="form-label__text" i18n="@@adminSystem.sectionGroupDetails.label.functions">この代理店経由の顧客が共通で利用する機能</span>
        </div>
        <div class="role-checkboxes">
            <div formGroupName="functionAttributes" class="admin-dialog__section">
              @for (func of common.SectionGroupFunctions; track func.code) {
                <label class="role-checkbox">
                  <mat-checkbox [formControlName]="func.code" color="primary"></mat-checkbox>
                  <span class="role-checkbox__label">{{ func.desc }}</span>
                </label>
              }
            </div>
        </div>
      </div>

      <div class="admin-dialog__divider"></div>
      
      <div class="admin-dialog__section">
        <div class="form-label">
          <span class="form-label__text" i18n="@@adminSystem.sectionGroupDetails.label.functions">この代理店経由の顧客が選択可能なユーザデータテンプレート</span>
        </div>
        <div class="role-checkboxes">
            <div formGroupName="userDataTemplateChoices" class="admin-dialog__section">
              @for (ud of userDataTemplates; track ud.id) {
                <label class="role-checkbox">
                  <mat-checkbox [formControlName]="getUdFormControlName(ud.id)" color="primary"></mat-checkbox>
                  <span class="role-checkbox__label">{{ ud.name }}</span>
                </label>
              }
            </div>
        </div>
      </div>

      <div class="admin-dialog__divider"></div>

      @if (distributorId != null) {
        <div class="admin-dialog__divider"></div>
        <div class="admin-dialog__section">
          <div class="form-label">
            <span class="form-label__text" i18n="@@adminSystem.distributorDetails.label.admins">エージェント</span>
          </div>
          <select multiple id="agentSelect" class="legacy-select legacy-select--multi">
            @for (agent of agents(); track $index) {
              <option [value]="agent.userId">
                {{ agent.lastName }} {{ agent.firstName }}
              </option>
            }
          </select>
          @if (hasSectionGroupAdminManagement || hasAllSectionGroupManagement || hasDistributorManagement) {
            <div class="admin-action-row">
              <!-- <button mat-stroked-button type="button" (click)="createAdmin()">
                <mat-icon>person_add</mat-icon>
                <span i18n="@@adminSystem.distributorDetails.button.createAdmin">エージェント作成</span>
              </button> -->
              <button mat-stroked-button type="button" (click)="inviteAgent()">
                <mat-icon>send</mat-icon>
                <span i18n="@@adminSystem.distributorDetails.button.inviteAgent">エージェント招待</span>
              </button>
            </div>
          }
        </div>
      }

    </form>
  </div>

  <!-- Footer -->
  <div class="admin-dialog__footer">
    @if (!changesMade) {
      <button mat-stroked-button (click)="onNoClick()">
        <span i18n="@@adminSystem.distributorDetails.button.close">閉じる</span>
      </button>
    } @else {
      <button mat-stroked-button color="warn" (click)="onNoClick()">
        <span i18n="@@adminSystem.distributorDetails.button.discard">破棄</span>
      </button>
    }
    @if (canUpdate) {
      <button mat-flat-button color="primary" [disabled]="isSending()" (click)="onEditOrUploadClicked()">
        @if (isSending()) {
          <mat-spinner diameter="18"></mat-spinner>
        }
        <span i18n="@@adminSystem.distributorDetails.button.action">{{ mode === Mode.disp ? '編集' : mode === Mode.create ? '作成' : '保存' }}</span>
      </button>
    }
  </div>
</div>
